// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"ProfileImage_imageContainer__bDGmf","imageContainerLarge":"ProfileImage_imageContainerLarge__wB5Qa","image":"ProfileImage_image__JymSy"};